import {
	buildPageStaggerIndexMap,
	computePageStaggerTimings,
	shouldApplyStaggerPageElementTransition,
} from "./erPageStaggerUtils";

export { buildPageStaggerIndexMap as buildScatterStaggerIndexMap };

export function shouldApplyScatterPageElementTransition(ctx) {
	return shouldApplyStaggerPageElementTransition("scatter", ctx);
}

function scatterOffsetForElement(element, canvasW = 960, canvasH = 540) {
	const cx = (Number(element?.x) || 0) + (Number(element?.width) || 0) / 2;
	const cy = (Number(element?.y) || 0) + (Number(element?.height) || 0) / 2;
	const dx = cx - canvasW / 2;
	const dy = cy - canvasH / 2;
	const dist = Math.hypot(dx, dy) || 1;
	const nx = dx / dist;
	const ny = dy / dist;
	let hash = 0;
	const id = String(element?.elementId ?? "");
	for (let i = 0; i < id.length; i += 1) hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
	const mag = 72 + (Math.abs(hash) % 56);
	return {
		x: `${Math.round(nx * mag)}px`,
		y: `${Math.round(ny * mag)}px`,
	};
}

export function getScatterPageTransitionElementStyle(staggerIndex, totalCount, durationMs, element) {
	const idx = Math.max(0, staggerIndex || 0);
	const { panelSec, delaySec } = computePageStaggerTimings(durationMs, totalCount, { panelRatio: 0.42 });
	const off = scatterOffsetForElement(element);
	return {
		opacity: 0,
		transformOrigin: "center center",
		"--er-scatter-x": off.x,
		"--er-scatter-y": off.y,
		animation: `er-page-scatter-panel ${panelSec}s cubic-bezier(0.22, 1, 0.36, 1) ${delaySec(idx)}s both`,
		willChange: "opacity, transform, filter",
	};
}

export function getScatterPageBackgroundStyle(durationMs) {
	const { totalSec } = computePageStaggerTimings(durationMs, 1, { panelRatio: 0.35 });
	const sec = Math.max(0.25, totalSec * 0.45);
	return {
		opacity: 0,
		animation: `er-page-scatter-bg ${sec}s ease-out both`,
		willChange: "opacity",
	};
}
